<template>
    <div
        v-if="shortDomain.id"
        class="box-body"
    >
        <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Name:</strong>
                <p>{{ shortDomain.name }}</p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>IP:</strong>
                <p>{{ shortDomain.formatted_ip }}</p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Parsed At:</strong>
                <p>{{ shortDomain.created_at }}</p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Updated At:</strong>
                <p>{{ shortDomain.updated_at }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Status:</strong>
                <p>
                    <span :class="'label bg-' + shortDomain.formatted_status_color">
                        {{ shortDomain.formatted_status }}
                    </span>
                </p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Active:</strong>
                <p>
                    <ValueYesNo :value="shortDomain.active" />
                </p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Created At:</strong>
                <p>{{ shortDomain.formatted_created_at }}</p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Expires At:</strong>
                <p>{{ shortDomain.formatted_expires_at }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Reusable:</strong>
                <p>
                    <ValueYesNo :value="shortDomain.reusable" />
                </p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Relation:</strong>
                <p>
                    <span v-if="shortDomain.domainable_type === type.campaign">
                        <a
                            v-if="shortDomain.domainable_id"
                            :href="getRoute(shortDomain.domainable_id, 'campaignsShow')"
                        >
                            Lap #{{ shortDomain.domainable_id }}
                        </a>
                        <em
                            v-else
                            class="text-info"
                            >Lap</em
                        >
                    </span>
                    <span v-else-if="shortDomain.domainable_type === type.feedback">
                        <a
                            v-if="shortDomain.domainable_id"
                            :href="getRoute(shortDomain.domainable_id, 'feedbackShow')"
                        >
                            Lap #{{ shortDomain.domainable_id }}
                        </a>
                        <em
                            v-else
                            class="text-info"
                            >Feedbacks</em
                        >
                    </span>
                    <span v-else>
                        <em class="text-info">None</em>
                    </span>
                </p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Order Uses:</strong>
                <p>
                    <BadgeTotal
                        :value="shortDomain.order_uses"
                        color="gray"
                    />
                </p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Used:</strong>
                <p>
                    <BadgeTotal
                        :value="shortDomain.used"
                        color="gray"
                    />
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Messages:</strong>
                <p>
                    <img
                        v-show="!isLoaded"
                        alt="Preloader"
                        class="table-row-preloader"
                        rel="preload"
                        src="/img/table-row-preloader.gif"
                    />
                    <BadgeTotal
                        v-show="isLoaded"
                        :value="shortDomain.messages_count"
                        color="gray"
                        title="Total"
                    />
                    <BadgeTotal
                        v-show="isLoaded"
                        :value="shortDomain.messages_sent"
                        color="green"
                        title="Sent"
                    />
                    <BadgeTotal
                        v-show="isLoaded"
                        :value="shortDomain.messages_failed"
                        color="red"
                        title="Failed"
                    />
                    <BadgeTotal
                        v-show="isLoaded"
                        :value="shortDomain.messages_blacklisted"
                        color="black"
                        title="Blacklisted"
                    />
                </p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Clicks:</strong>
                <p>
                    <img
                        v-show="!isLoaded"
                        alt="Preloader"
                        class="table-row-preloader"
                        rel="preload"
                        src="/img/table-row-preloader.gif"
                    />
                    <BadgeTotal
                        v-show="isLoaded"
                        :value="shortDomain.clicks_count"
                        color="aqua-active"
                        title="Amount"
                    />
                </p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <strong>Redirect URL:</strong>
                <p>
                    <span v-if="shortDomain.redirect_url">{{ shortDomain.redirect_url }}</span>
                    <em
                        v-else
                        class="text-info"
                    >
                        None
                    </em>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import ValueYesNo from '../subcomponents/ValueYesNo';
import BadgeTotal from '../subcomponents/BadgeTotal';

export default {
    components: {
        ValueYesNo,
        BadgeTotal,
    },
    data: function () {
        return {
            shortDomain: {},
            stats: {},
            isLoaded: false,
            route: {
                feedbackShow: '/feedback/:id:',
                campaignsShow: '/campaigns/:id:',
                sdAccountsShow: '/sd-accounts/:id:',
            },
            type: {
                campaign: 'SMSPlatform\\Models\\Campaign\\Campaign',
                feedback: 'SMSPlatform\\Models\\Feedback\\Feedback',
            },
            collapse: true,
            durationCollapse: 700,
        };
    },
    mounted() {
        this.getData(this.$route.params.id);
    },
    methods: {
        async getData(id) {
            this.isLoaded = false;
            const { data } = await axios.get(`/short-domains/${id}/data`);

            this.shortDomain = data;
            this.getStats(data.id);
            this.$emit('loaded', true);
            this.$emit('shortDomain', data);
        },
        getStats(id) {
            axios.get('/short-domains/' + id + '/stats?ids=' + id).then((response) => {
                this.isLoaded = true;
                this.shortDomain = { ...this.shortDomain, ...response.data[0] };
            });
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        changeIcon: function (value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
        toggleCollapse() {
            this.collapse = !this.collapse;
        },
    },
};
</script>
